import { Action, createReducer, on } from '@ngrx/store'

import { initialCreateMenu, initialMenu } from './inital-menu'
import { menuActions } from './menu.actions'
import { MenuState } from './menu.state'

export const initialState: MenuState = {
  menuItems: initialMenu,
  createItems: initialCreateMenu,
  isLoading: false
}

const reducer = createReducer(
  initialState,
  on(menuActions.setMenu, (state, { menuItems }) => ({
    ...state,
    menuItems,
    isLoading: false
  })),
  on(menuActions.resetState, (state) => ({
    ...initialState
  })),
)

export function menuReducer(
  state: MenuState | undefined,
  action: Action
): MenuState {
  return reducer(state, action)
}
